import React from 'react';
import { TFunction } from 'i18next';
import dayjs from 'dayjs';

import { BonusCardType, IBonusCardProps } from '.';

import { ReactComponent as ExpirationIcon } from 'theme/assets/images/expiration.svg';
import { ReactComponent as LockIcon } from 'theme/assets/images/lock.svg';
import { ReactComponent as CheckIcon } from 'theme/assets/images/check.svg';
import { BonusIdentifier, BonusStatus } from 'constants/appEnums';

type ReactSVG = React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
>;

const dateFormat: string = 'DD/MM/YYYY';

export function getCardStatus(
  t: TFunction,
  card: IBonusCardProps
): {
  active: boolean;
  statusIcon: ReactSVG;
  statusText: string;
  style: 'highlighted' | 'plain';
} {
  switch (card.type) {
    case BonusCardType.ReadyToUse:
      switch (card.status) {
        case BonusStatus.active:
          return {
            active: true,
            statusIcon: CheckIcon,
            statusText: t('bonus-activated'),
            style: 'highlighted'
          };

        case BonusStatus.available:
          return {
            active: true,
            statusIcon: ExpirationIcon,
            statusText: `${t('expires')} ${dayjs(card.expirationDate).format(dateFormat)}`,
            style: 'plain'
          };

        case BonusStatus.unavailable:
          return {
            active: true,
            statusIcon: LockIcon,
            statusText: t('weekly-bonus-limit-reached'),
            style: 'plain'
          };
      }
      break;

    case BonusCardType.Locked:
      return {
        active: false,
        statusIcon: LockIcon,
        statusText: t('bet-10-within-last-7-days'),
        style: 'plain'
      };
  }
}

export function getCardDetails(
  t: TFunction,
  card: IBonusCardProps
): {
  icon: string;
  name: string;
  description: string;
} {
  switch (card.identifier) {
    case BonusIdentifier.NewSigning:
      return {
        name: t(BonusIdentifier.NewSigning),
        description: t('not-a-fan-of-a-player-you-revealed'),
        icon: BonusIdentifier.NewSigning
      };

    case BonusIdentifier.DecisionTime:
      return {
        name: t(BonusIdentifier.DecisionTime),
        description: t('have-the-option-of-two-players-to-choose-from-on-friday'),
        icon: BonusIdentifier.DecisionTime
      };
  }
}
